import { Box, CircularProgress } from '@mui/material';
import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router';
import { ErrorBoundary } from './components/ErrorBoundary';
import { SpotlightEffect } from './components/ui/SpotlightEffect';
import { ThemeModeProvider } from './contexts/ThemeModeContext';
import { HomePage } from './pages/Home';

// Lazy load non-critical pages
const AboutPage = lazy(() => import('./pages/About').then((m) => ({ default: m.AboutPage })));
const ContactPage = lazy(() => import('./pages/Contact').then((m) => ({ default: m.ContactPage })));
const ProjectsPage = lazy(() =>
  import('./pages/Projects').then((m) => ({ default: m.ProjectsPage })),
);
const SkillsPage = lazy(() => import('./pages/Skills').then((m) => ({ default: m.SkillsPage })));
const NotFoundPage = lazy(() =>
  import('./pages/NotFound').then((m) => ({ default: m.NotFoundPage })),
);

const PageLoader = () => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      bgcolor: 'background.default',
    }}
  >
    <CircularProgress />
  </Box>
);

function App() {
  return (
    <ErrorBoundary>
      <ThemeModeProvider>
        <Router>
          <SpotlightEffect />
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/skills" element={<SkillsPage />} />
              <Route path="/projects" element={<ProjectsPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Suspense>
        </Router>
      </ThemeModeProvider>
    </ErrorBoundary>
  );
}

export default App;
